<div class="video-timeline-container">
  <!-- Video Player (if file is video) -->
  @if (transcription && transcription.content && transcription.content.length > 0 && isVideoFile) {
    <div class="video-player-container" [class.hidden]="!isVideoVisible">
      <video
        #videoPlayer
        [src]="transcription.fileUrl"
        (loadedmetadata)="onVideoLoaded()"
        (timeupdate)="onVideoTimeUpdate()"
        (error)="onVideoError($event)">
        Your browser does not support the video tag.
      </video>

      <!-- Captions Overlay -->
      @if (captionsEnabled && currentCaption) {
        <div class="captions-overlay">
          <div class="caption-text" [ngStyle]="getCaptionStyles(currentCaption)">
            {{ currentCaption.text }}
          </div>
        </div>
      }
    </div>
  }

  <!-- Timeline visualization -->
  <div class="timeline-wrapper">
    <div
      class="timeline"
      #timeline
      (click)="onTimelineClick($event)">

      <!-- Background track -->
      <div class="timeline-track"></div>

      <!-- Transcription segments -->
      <div
        class="timeline-segment"
        *ngFor="let segment of timelineSegments"
        [style.left.%]="segment.startPercent"
        [style.width.%]="segment.widthPercent"
        [style.background-color]="segment.color"
        [matTooltip]="getSegmentTooltip(segment)"
        [matTooltipPosition]="'above'"
        (click)="onSegmentClick(segment, $event)">
      </div>

      <!-- Current time indicator -->
      <div
        class="time-indicator"
        [style.left.%]="getCurrentTimePercent()">
        <div class="indicator-line"></div>
        <div class="indicator-handle"></div>
      </div>
    </div>

    <!-- Time labels -->
    <div class="time-labels">
      <span class="time-current">{{ formatTime(currentTime) }}</span>
      <span class="time-end">{{ formatTime(totalDuration) }}</span>
    </div>
  </div>

  <!-- Control buttons -->
  <div class="controls">
    <!-- Left section: video/text/caption toggles -->
    <div class="controls-left">
      <!-- Hide/show video - only show for video files -->
      <button
        *ngIf="isVideoFile"
        mat-icon-button
        (click)="toggleVideoVisibility()"
        [matTooltip]="isVideoVisible ? ('VIDEO_TIMELINE.HIDE_VIDEO' | translate) : ('VIDEO_TIMELINE.SHOW_VIDEO' | translate)"
        class="video-visibility-btn"
        [class.active]="isVideoVisible">
        <mat-icon>{{ isVideoVisible ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>

      <!-- Merge/segment text - applies to all transcriptions -->
      <button
        mat-icon-button
        (click)="toggleMergedText()"
        [matTooltip]="mergedTextEnabled ? ('VIDEO_TIMELINE.SHOW_SEGMENTS' | translate) : ('VIDEO_TIMELINE.MERGE_TEXT' | translate)"
        class="merge-text-btn"
        [class.active]="mergedTextEnabled">
        <mat-icon>{{ mergedTextEnabled ? 'format_list_bulleted' : 'notes' }}</mat-icon>
      </button>

      <!-- Captions toggle - only show for video files -->
      <button
        *ngIf="isVideoFile"
        mat-icon-button
        (click)="toggleCaptions()"
        [matTooltip]="captionsEnabled ? ('VIDEO_TIMELINE.HIDE_CAPTIONS' | translate) : ('VIDEO_TIMELINE.SHOW_CAPTIONS' | translate)"
        class="captions-btn"
        [class.active]="captionsEnabled">
        <mat-icon>{{ captionsEnabled ? 'closed_caption' : 'closed_caption_disabled' }}</mat-icon>
      </button>
    </div>

    <!-- Center section: Playback controls -->
    <div class="controls-center">
      <button
        mat-icon-button
        (click)="goToStart()"
        matTooltip="{{ 'VIDEO_TIMELINE.TO_START' | translate }}">
        <mat-icon>skip_previous</mat-icon>
      </button>

      <button
        mat-icon-button
        (click)="goToPreviousSegment()"
        matTooltip="{{ 'VIDEO_TIMELINE.PREVIOUS_SEGMENT' | translate }}">
        <mat-icon>first_page</mat-icon>
      </button>

      <button
        mat-icon-button
        class="play-pause-btn"
        (click)="togglePlayPause()"
        [matTooltip]="isPlaying ? ('VIDEO_TIMELINE.PAUSE' | translate) : ('VIDEO_TIMELINE.PLAY' | translate)">
        <mat-icon>{{ isPlaying ? 'pause' : 'play_arrow' }}</mat-icon>
      </button>

      <button
        mat-icon-button
        (click)="goToNextSegment()"
        matTooltip="{{ 'VIDEO_TIMELINE.NEXT_SEGMENT' | translate }}">
        <mat-icon>last_page</mat-icon>
      </button>

      <button
        mat-icon-button
        (click)="goToEnd()"
        matTooltip="{{ 'VIDEO_TIMELINE.TO_END' | translate }}">
        <mat-icon>skip_next</mat-icon>
      </button>
    </div>

    <!-- Right section: Volume control -->
    <div class="controls-right">
      <div class="volume-control">
        <mat-icon class="volume-icon" (click)="toggleMute()">{{ getVolumeIcon() }}</mat-icon>
        <mat-slider
          class="volume-slider"
          min="0"
          max="100"
          step="1"
          matTooltip="{{ volume }}%">
          <input matSliderThumb [value]="volume" (input)="onVolumeChange($event)">
        </mat-slider>
      </div>
    </div>
  </div>

  <!-- Hidden audio element -->
  <audio
    #audioPlayer
    [src]="audioUrl"
    (loadedmetadata)="onAudioLoaded()"
    (timeupdate)="onAudioTimeUpdate()"
    (ended)="onAudioEnded()"
    (error)="onAudioError($event)">
  </audio>
</div>